// extracted by mini-css-extract-plugin
export default {"benefit":"_d68ae617","icon":"_1572350b","text":"_3f02841d"};